/* eslint react/prop-types: 0 */
import React, { Component } from 'react';
import enhancer from './enhancer';
import { defaultProps } from './types';

class Circle extends Component {
  static defaultProps = {
    ...defaultProps,
    gapPosition: 'top',
  };

  getPathStyles() {
    const { percent, strokeWidth, gapDegree = 0, gapPosition } = this.props;
    const radius = 50 - strokeWidth / 2;
    let beginPositionX = 0;
    let beginPositionY = -radius;
    let endPositionX = 0;
    let endPositionY = -2 * radius;
    switch (gapPosition) {
      case 'left':
        beginPositionX = -radius;
        beginPositionY = 0;
        endPositionX = 2 * radius;
        endPositionY = 0;
        break;
      case 'right':
        beginPositionX = radius;
        beginPositionY = 0;
        endPositionX = -2 * radius;
        endPositionY = 0;
        break;
      case 'bottom':
        beginPositionY = radius;
        endPositionY = 2 * radius;
        break;
      default:
    }
    const pathString = `M 50,50 m ${beginPositionX},${beginPositionY}
     a ${radius},${radius} 0 1 1 ${endPositionX},${-endPositionY}
     a ${radius},${radius} 0 1 1 ${-endPositionX},${endPositionY}`;
    const len = Math.PI * 2 * radius;
    const trailPathStyle = {
      strokeDasharray: `${len - gapDegree}px ${len}px`,
      strokeDashoffset: `-${gapDegree / 2}px`,
      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s',
    };
    const strokePathStyle = {
      strokeDasharray: `${(percent / 100) * (len - gapDegree)}px ${len}px`,
      strokeDashoffset: `-${gapDegree / 2}px`,
      transition:
        'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s', // eslint-disable-line
    };
    return { pathString, trailPathStyle, strokePathStyle };
  }

  render() {
    const {
      prefixCls,
      strokeWidth,
      trailWidth,
      strokeColor,
      percent,
      trailColor,
      strokeLinecap,
      style,
      className,
      ...restProps
    } = this.props;
    const pathStyles = this.getPathStyles();
    const { pathString } = pathStyles;
    let { trailPathStyle, strokePathStyle } = pathStyles;
    trailPathStyle = trailColor ? { ...trailPathStyle, stroke: trailColor } : trailPathStyle;
    strokePathStyle = strokeColor ? { ...strokePathStyle, stroke: strokeColor } : strokePathStyle;
    delete restProps.percent;
    delete restProps.gapDegree;
    delete restProps.gapPosition;
    return (
      <svg
        className={`${prefixCls}-circle ${className}`}
        viewBox="0 0 100 100"
        style={style}
        {...restProps}
      >
        <path
          className={`${prefixCls}-circle-trail`}
          d={pathString}
          stroke={trailColor}
          strokeWidth={trailWidth || strokeWidth}
          fillOpacity="0"
          style={trailPathStyle}
        />
        <path
          className={`${prefixCls}-circle-path`}
          d={pathString}
          strokeLinecap={strokeLinecap}
          stroke={strokeColor}
          strokeWidth={this.props.percent === 0 ? 0 : strokeWidth}
          fillOpacity="0"
          ref={path => {
            this.path = path;
          }}
          style={strokePathStyle}
        />
      </svg>
    );
  }
}

export default enhancer(Circle);
